import React from 'react';
import PropTypes from 'prop-types';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import ConsigneeCharges from './ConsigneeCharges';
import ManagedAccountingSummary from './ManagedAccountingSummary';

const CONSIGNEE = 'Consignee';
const RECEIVABLES = 'Receivables';
const PAYABLES = 'Payables';
export default function ConsigneeAccounting({ shipment }) {
  const {
    _id: shipmentId,
    market: { timezone },
    managed_receivables,
    managed_payables,
    current: shipmentIsCurrent,
    currency,
  } = shipment;

  const consigneeReceivables = managed_receivables.filter(
    (i) => i.payer_type === CONSIGNEE,
  );
  const consigneePayables = managed_payables.filter(
    (i) => i.payer_type === CONSIGNEE,
  );

  const totalReceivableRate = getLedgerTotal(consigneeReceivables);
  const totalPayableRate = getLedgerTotal(consigneePayables);
  const intermodalShipmentType = isIntermodalShipmentType(shipment);

  return (
    (<div data-testid="div-e45ec0e7" className="">
      <ManagedAccountingSummary
        receivableTotal={totalReceivableRate}
        payableTotal={totalPayableRate}
        intermodalShipmentType={intermodalShipmentType}
        customerType={CONSIGNEE}
        currency={currency}
      />
      <div data-testid="div-4e7cb041" className="mb-8">
        <ConsigneeCharges
          shipmentId={shipmentId}
          timezone={timezone}
          charges={consigneeReceivables}
          type={RECEIVABLES}
          total={totalReceivableRate}
          isIntermodalShipmentType={intermodalShipmentType}
          shipmentIsCurrent={shipmentIsCurrent}
        />
      </div>
      <div data-testid="div-dab752cb" className="mb-8">
        <ConsigneeCharges
          shipmentId={shipmentId}
          timezone={timezone}
          total={totalPayableRate}
          charges={consigneePayables}
          type={PAYABLES}
          isIntermodalShipmentType={intermodalShipmentType}
          shipmentIsCurrent={shipmentIsCurrent}
        />
      </div>
    </div>)
  );
}

ConsigneeAccounting.propTypes = {
  shipment: PropTypes.object,
};

function getLedgerTotal(ledgerItems = []) {
  return ledgerItems.reduce(
    (total, ledgerItem) => total + (ledgerItem.value || 0),
    0,
  );
}
